import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-tell_us_more_page_next_button-click';
/**
 * Event that tracks the next button being clicked on the &quot;Tell us more&quot; page for self-service. First param is the issue name chain that the user selected, which should be formatted as ${issueL1}-${issueL2}-${issueL3}-${issueL4}
 */
export function trackCxFoundationsTellUsMorePageNextButtonClick(issue_name_chain, brandretailer_token2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { issue_name_chain, brandretailer_token2 },
    });
}
